import BarChart from '@mui/icons-material/BarChart';

import { Catastrophic, Critical, High, Low, Medium } from '../Icons/Severity';
import * as Colors from './colors';

export enum SeverityLevel {
  'Total' = 'total',
  'Critical' = 'critical',
  'High' = 'high',
  'Medium' = 'medium',
  'Low' = 'low',
}

export const severityColor = (severity?: string) => {
  switch (severity) {
    case SeverityLevel.Total:
      return Colors.total.primary;
    case 'catastrophic':
      return Colors.catastrophic.primary;
    case SeverityLevel.Critical:
      return Colors.critical.primary;
    case SeverityLevel.High:
      return Colors.high.primary;
    case SeverityLevel.Medium:
      return Colors.medium.primary;
    case SeverityLevel.Low:
      return Colors.low.primary;
    default:
      return Colors.grey[400];
  }
};

export const severityIcon = (
  severity?: string,
  size?: string,
  color?: string,
) => {
  switch (severity) {
    case SeverityLevel.Total:
      return <BarChart width={size} sx={{ color: `${color ?? 'primary'}` }} />;
    case 'catastrophic':
      return <Catastrophic width={size} color="error" />;
    case SeverityLevel.Critical:
      return <Critical width={size} color={color} />;
    case SeverityLevel.High:
      return <High width={size} color={color} />;
    case SeverityLevel.Medium:
      return <Medium width={size} color={color} />;
    case SeverityLevel.Low:
      return <Low width={size} color={color} />;
    default:
      return null;
  }
};

export const severityByCategoryColorPalette = (severity: string) => {
  switch (severity) {
    case SeverityLevel.Total:
      return Object.values(Colors.total).reverse();
    case 'catastrophic':
      return Object.values(Colors.catastrophic).reverse();
    case SeverityLevel.Critical:
      return Object.values(Colors.critical).reverse();
    case SeverityLevel.High:
      return Object.values(Colors.high).reverse();
    case SeverityLevel.Medium:
      return Object.values(Colors.medium).reverse();
    case SeverityLevel.Low:
      return Object.values(Colors.low).reverse();
    default:
      return undefined;
  }
};
